import React from "react";
import { Tooltip, IconButton } from "@mzc-pdc/ui";
import { IconFolderAdd } from "@mzc-cloudplex/icons";
import useCheckPermission from "@hooks/useCheckPermission";
import i18n from "@lib/i18n";

const TreeViewActions = ({ onToggleModal }) => {
    const FOLDERS_PERMISSIONS = useCheckPermission({ scope: "Project", domain: "Folders" });

    return (
        <>
            <Tooltip title={i18n.t(`common::label::New Folder`, `New Folder`)}>
                <IconButton
                    circled
                    size={"medium"}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleModal("createFolder", true);
                    }}
                    disabled={!FOLDERS_PERMISSIONS.EDIT}
                >
                    <IconFolderAdd size={16} color={"greySecondary"} />
                </IconButton>
            </Tooltip>
        </>
    );
};

export default TreeViewActions;
